import { Box, IconButton, Tooltip } from "@mui/material";
import Icon from "@mdi/react";
import { mdiClose, mdiExportVariant } from "@mdi/js";

import ContrastIcon from "components/ContrastIcon";
import useBoundStore from "store";
import { isIOS, isInStandaloneMode } from "utils/device";
import styles from "./IOSAddToHomeScreenTooltip.module.scss";

function IOSAddToHomeScreenTooltip() {
  const iOSAddToHomeScreenTooltip = useBoundStore((state) => state.miscellaneous.showIOSAddToHomeScreenTooltip);
  const setMiscellaneous = useBoundStore((state) => state.miscellaneous.set);

  const handleCloseTooltip = () => {
    setMiscellaneous({ showIOSAddToHomeScreenTooltip: false });
  };

  return isIOS() && !isInStandaloneMode() ? (
    <Tooltip
      arrow
      open={iOSAddToHomeScreenTooltip}
      title={
        <Box display='flex'>
          <span>
            Install this web app on your iPhone: press on
            <Icon className={styles.exportVariantIcon} path={mdiExportVariant} size={0.75} />
            and then &#39;Add to Home Screen&#39;.
          </span>
          <IconButton aria-label='Close tooltip' onClick={handleCloseTooltip} size='small'>
            <ContrastIcon path={mdiClose} size={0.75} />
          </IconButton>
        </Box>
      }
      placement='top'
    >
      <div className={styles.placement} />
    </Tooltip>
  ) : null;
}

export default IOSAddToHomeScreenTooltip;
